import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import RouterConstants from "../../../../../../constants/RouterConstants";
import { useAppStore } from "../../../../../../hooks/useStores";
import FiboCreateTgModel from "../../../../Models/FiboCreate/FiboCreateTgModel.tsx";
import { isLegacyTgRoute } from "../../../../utils/tg-utils.ts";
import { ViewTgProjectLocationState } from "../../TgProjectViewer";

export const FiboCreateTgProjectModel = () => {
	const { t } = useTranslation("tg", { keyPrefix: "projects.viewer.models.create" });
	const { t: tViewer } = useTranslation("tg", { keyPrefix: "projects.viewer" });
	const { tgStore, uiStore } = useAppStore();
	const { tgProjectStore } = tgStore;
	const { projectId } = useParams();

	useEffect(() => {
		uiStore.hideSideBar();

		uiStore.showBackButton(
			`${
				isLegacyTgRoute()
					? RouterConstants.NEW_TG.LEGACY.PROJECTS.fullPath
					: RouterConstants.NEW_TG.PROJECTS.fullPath
			}/${projectId}/${RouterConstants.NEW_TG.MODELS.path}`,
			undefined,
			t("backButton", { projectName: tgProjectStore.projectToView.project_name || "Project" }),
			true,
			false,
			async () => {
				uiStore.hideBackButton();
			},
			undefined,
			undefined,
			tViewer("backConfirm.description"),
			tViewer("backConfirm.confirm"),
			tViewer("backConfirm.cancel"),
			true,
			true,
		);

		if (!tgProjectStore.projectToView.id && projectId) {
			tgProjectStore.getProject(Number(projectId)).then((project) => (tgProjectStore.projectToView = project));
		}

		return () => {
			uiStore.showSideBar();
			uiStore.hideBackButton();
		};
	}, []);

	useEffect(() => {
		if (tgProjectStore.projectToView.id) {
			const viewProjectState: ViewTgProjectLocationState = { projectToView: toJS(tgProjectStore.projectToView) };

			uiStore.showBackButton(
				`${
					isLegacyTgRoute()
						? RouterConstants.NEW_TG.LEGACY.PROJECTS.fullPath
						: RouterConstants.NEW_TG.PROJECTS.fullPath
				}/${projectId}/${RouterConstants.NEW_TG.MODELS.path}`,
				{ state: viewProjectState },
				t(`backButton`, { projectName: tgProjectStore.projectToView.project_name }),
				true,
				false,
				async () => {
					uiStore.hideBackButton();
				},
				undefined,
				undefined,
				tViewer("backConfirm.description"),
				tViewer("backConfirm.confirm"),
				tViewer("backConfirm.cancel"),
				true,
				true,
			);
		}
	}, [tgProjectStore.projectToView.id]);

	return <FiboCreateTgModel />;
};

export default observer(FiboCreateTgProjectModel);
